/**
 * DataTableFilters class
 *
 * @package    DataTable
 * @author     Maxim Lukianenko <mlukianenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

import Filter from './Filter';
import { DataTableColumnType } from 'Types';
import ItemGrid from 'Common/Grid/ItemGrid';
import Button from 'Common/CustomButtons/Button';
import SearchIcon from '@material-ui/icons/Search';

export default class DataTableFilters extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        columns: PropTypes.arrayOf(DataTableColumnType).isRequired,
        where: PropTypes.object,
        has: PropTypes.object,
        setWhere: PropTypes.func.isRequired,
        showFilters: PropTypes.bool,
        sizedFilters: PropTypes.bool,
        search: PropTypes.bool,
        handleSearch: PropTypes.func,
    };

    /**
     * DefaultProps
     */
    static defaultProps = {
        where: {},
        search: false
    };

    render() {
        const { columns, setWhere, where, has, showFilters, sizedFilters, search, handleSearch } = this.props;

        return (
            <div className="rt-thead -filters" style={showFilters ? {} : {display: 'none'}}>
                <Grid container direction="row" justify="center">
                    {columns.map(column => {
                        let filter = column.relation && has && has[column.relation]?
                            (typeof has[column.relation].where[column.filterKey ? column.filterKey : column.key] !== 'object' || column.operator) && has[column.relation].where[column.filterKey ? column.filterKey : column.key] :
                            (typeof where[column.filterKey ? column.filterKey : column.key] !== 'object' || column.operator) && where[column.filterKey ? column.filterKey : column.key];

                        return (search !== !!column.search ? null :
                            sizedFilters ?
                                <ItemGrid
                                    key={ column.key }
                                    xs={ 12 }
                                    sm={ 12 }
                                    md={ column.filterSize ? column.filterSize : 3 }
                                    className={ column.filterClassName + ' mm-table-filter' }
                                >
                                    <Filter
                                        column={ column }
                                        setWhere={ setWhere }
                                        filter={ filter }
                                        handleSearch={ handleSearch }
                                    />
                                </ItemGrid> :
                                <Grid
                                    key={ column.key }
                                    item
                                    md
                                    className="mm-table-filter"
                                >
                                    <Filter
                                        column={ column }
                                        setWhere={ setWhere }
                                        filter={ filter }
                                        handleSearch={ handleSearch }
                                    />
                                </Grid>);
                    })}
                    {search &&
                        <Button
                            color="warning"
                            type="button"
                            round
                            onClick={() => handleSearch()}
                            customClass={'filters-search-btn'}
                        >
                            <SearchIcon/>
                        </Button>
                    }
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableFilters/DataTableFilters.jsx